import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { jobData } from './slice'
import { jobAPI } from '../../api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    let requestParams = {
      includes: [
        'user',
        'jobType',
        'profileExperienceYear',
        'languages',
        'skills',
        'locationCity',
        'locationProvince',
        'profileStudyProgram',
        'profileStudyArea',
        'profileCertifications',
      ],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(jobAPI.getJob, id, requestParams)

    const { data } = response

    yield put(jobData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(jobData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeLatest(jobData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
